import React from "react";

const rowCenterFlexEnd = (): React.CSSProperties => {
  return { display: "flex", alignItems: "flex-end", flexDirection: "row" };
};

export default rowCenterFlexEnd;
